import React from "react";
import { Helmet } from "react-helmet-async";
import "./examPackageMutetElott.css";
import HeroBanner from "../../../Hero/HeroBanner";
import HeroPicBig from "../../../../../assets/medical/examinations/packages/mutet_elotti/mutet_elotti_banner_nagy.png";
import HeroPicSmall from "../../../../../assets/medical/examinations/packages/mutet_elotti/mutet_elotti_banner_kicsi.png";
import GoToPrice from "../GoToPrice/GoToPrice";
import { examinationPackages } from "../../exams/examinationPackages";
import ExamContent from "../ExamContent/ExamContent";
import ExamCTA from "../../ExamCTA/ExamCTA";

const ExamPackageMutetElott = () => {
  const mutetElottiTitle = examinationPackages[1].name;
  const mutetElottiSuggestedTo = examinationPackages[1].suggestedTo;
  const mutetElottiContains = examinationPackages[1].contains;

  // Create structured data for pre-surgery testing
  const preSurgeryTestingStructuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    "name": "Műtét előtti kivizsgálás - Bálint Analitika",
    "description": "A Bálint Analitika laboratórium műtét előtti kivizsgálás csomagja, amely tartalmazza a műtét előtt szükséges laborvizsgálatokat.",
    "relevantSpecialty": ["Surgery", "Anesthesiology", "GeneralPractice"],
    "medicineSystem": "Conventional Medicine",
    "usedToDiagnose": "Pre-surgical health assessment",
    "normalRange": "Varies by individual test",
    "affectedBy": ["Age", "Existing health conditions", "Medications"],
    "procedure": "Blood test panel and other pre-surgical examinations",
    "serviceProvider": {
      "@type": "MedicalBusiness",
      "name": "Bálint Analitika Laboratórium",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Kondorfa utca 6.",
        "addressLocality": "Budapest",
        "postalCode": "1116",
        "addressRegion": "XI. kerület",
        "addressCountry": "HU"
      }
    },
    "offers": {
      "@type": "Offer",
      "availability": "InStock",
      "priceCurrency": "HUF",
      "priceSpecification": {
        "@type": "PriceSpecification",
        "price": "Varies by package"
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>Műtét előtti kivizsgálás | Laborvizsgálatok | Bálint Analitika</title>
        <meta 
          name="description" 
          content="Műtét előtti kivizsgálás és laborvizsgálatok a Bálint Analitika budapesti laboratóriumában. Gyors és pontos eredmények, szakmai konzultációval."
        />
        <meta
          name="keywords"
          content="műtét előtti kivizsgálás, műtét előtti laborvizsgálat, sebészeti előkészítés, műtéti rizikó felmérés, preoperatív vizsgálatok, Budapest"
        />
        <link 
          rel="canonical" 
          href="https://balintanalitika.hu/orvosdiagnosztika/vizsgalatok/csomagok/mutet-elotti"
        />
        <script type="application/ld+json">
          {JSON.stringify(preSurgeryTestingStructuredData)}
        </script>
      </Helmet>

      <HeroBanner 
        srcBig={HeroPicBig} 
        srcSmall={HeroPicSmall} 
        alt="Műtét előtti kivizsgálás és laborvizsgálatok a Bálint Analitika laboratóriumban"
      />

      <main className="exam-package-page container">
        <header className="exam-package-header">
          <h1 className="heading-primary">Műtét előtti kivizsgálás</h1>
          <p className="exam-company-contact-text">
            A műtét előtti kivizsgálás elengedhetetlen a biztonságos sebészeti beavatkozásokhoz. 
            A Bálint Analitika budapesti laboratóriumában gyorsan és szakszerűen elvégezzük 
            a műtét előtt szükséges laborvizsgálatokat, hogy Ön és orvosa megfelelő információk 
            birtokában legyenek.
          </p>
        </header>

        <section className="exam-package-content">
          <ExamContent
            title={mutetElottiTitle}
            suggestedTo={mutetElottiSuggestedTo}
            items={mutetElottiContains}
            isPackage={false}
            itemType="https://schema.org/MedicalTest"
          />
          
          <div className="exam-package-additional-info">
            <h2 className="heading-secondary">Miért fontos a műtét előtti kivizsgálás?</h2>
            <p className="exam-company-contact-text">
              A műtét előtti laboratóriumi vizsgálatok segítenek felmérni a páciens általános 
              egészségi állapotát és azonosítani az esetleges kockázati tényezőket. Ezek az 
              információk elengedhetetlenek az aneszteziológus és a sebész számára a megfelelő 
              műtéti és érzéstelenítési terv kidolgozásához.
            </p>
            
            <h3 className="heading-tertiary">A műtét előtti kivizsgálás előnyei:</h3>
            <ul className="exam-package-list">
              <li>Potenciális kockázatok korai felismerése</li>
              <li>Az anesztézia típusának biztonságos megválasztása</li>
              <li>Műtét utáni szövődmények kockázatának csökkentése</li>
              <li>Személyre szabott perioperatív gondozás tervezése</li>
              <li>Lappangó betegségek felismerése</li>
            </ul>
          </div>

          <GoToPrice />
          
          <div className="exam-package-contact" itemScope itemType="https://schema.org/MedicalOrganization">
            <h3 className="heading-tertiary">Konzultáció és időpontfoglalás</h3>
            <p className="exam-company-contact-text">
              A műtét előtti kivizsgálással kapcsolatban szakértői konzultációt biztosítunk. 
              Keressen bennünket bizalommal Budapest XI. kerületében található laboratóriumunkban, 
              vagy az alábbi elérhetőségeken:
            </p>
            <ExamCTA />
          </div>
        </section>
      </main>
    </>
  );
};

export default ExamPackageMutetElott;